import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Divider } from 'antd';
import { EAppRoutes } from '@common/enums';
import emodoLogo from '@common/resources/images/emodo-logo.svg';
import * as Styled from './Header.styled';

interface HeaderProps {
  children?: ReactElement;
}

const Header: React.FC<HeaderProps> = ({ children }: HeaderProps): ReactElement => {
  return (
    <Styled.HeaderContainer>
      <Link to={EAppRoutes.Reporting} style={{ display: 'flex' }}>
        <img style={{ width: 120, height: 'auto' }} src={emodoLogo} alt='Company Logo' />
      </Link>
      <Divider type='vertical' style={{ margin: '0 24px', height: 32 }} />
      {children}
    </Styled.HeaderContainer>
  );
};

export default Header;
